import { render, staticRenderFns } from "./SubmitFeedbackModal.vue?vue&type=template&id=9d9cb1ae&"
import script from "./SubmitFeedbackModal.vue?vue&type=script&lang=ts&"
export * from "./SubmitFeedbackModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports